import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Get admin password from environment variable
    const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
    
    // Debug logging
    console.log('Environment password:', ADMIN_PASSWORD);
    console.log('Entered password:', password);
    console.log('Match:', password === ADMIN_PASSWORD);
    
    if (password === ADMIN_PASSWORD) {
      // Store auth in sessionStorage
      sessionStorage.setItem('adminAuth', 'true');
      navigate('/admin/dashboard');
    } else {
      setError('Invalid password');
      setPassword('');
    }
  };

  return (
    <div className="admin-login-container">
      <Helmet>
        <title>PourMyBev</title>
        <meta name="description" content="PourMyBev" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="admin-login-card">
        <div className="login-header">
          <h1>Admin Login</h1>
          <p>Enter password to access the dashboard</p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Enter admin password"
              className="password-input"
            />
            {error && <span className="error-message">{error}</span>}
          </div>
          
          <Button type="submit" className="login-button">
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;